<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Privacy</h5>
        <el-tooltip class="item" content="All respondents" placement="left">
          <span class="pull-right text-muted text-right count">
            <em>n</em> = {{ respondents }}
          </span>
        </el-tooltip>
      </div>

      <div class="ibox-content ibox-heading">
        Statistics for opt-ins / permission to process / age data.
      </div>

      <div class="ibox-content privacy-list-content">
        <div class="pull-right total-display">
          <el-radio-group v-model="selectedTotalDisplay" size="mini">
            <el-radio-button label="percentage">Percentage</el-radio-button>
            <el-radio-button label="total">Total</el-radio-button>
          </el-radio-group>
        </div>

        <el-table
          v-loading="isloading"
          :data="getOptins"
          :fit="true"
          :empty-text="'No Privacy Data'"
          style="width: 100%"
          max-height="400"
          row-key="type"
          stripe
        >
          <el-table-column label="Type" :class-name="'client-link'">
            <template #default="scope">
              {{ scope.row.type }}
            </template>
          </el-table-column>

          <el-table-column label="Yes">
            <template #default="scope">
              {{ totalDisplay(scope.row.count.yes) }}
            </template>
          </el-table-column>

          <el-table-column label="No">
            <template #default="scope">
              {{ totalDisplay(scope.row.count.no) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="ibox-tools el-download-btn">
        <el-button type="primary" size="small" class="ibox-tool-btn" plain @click="getPrivacyTypes">
          Export
        </el-button>
      </div>
    </div>

    <privacy-report-dialog
      v-if="downloadPrivacyVisible"
      :privacy="getOptins"
      :isVisible="downloadPrivacyVisible"
      @onVisibleChanged="handleDownloadPrivacyVisibilityChanged"
    />
  </div>
</template>

<script>
import collect from 'collect.js';
import PrivacyReportDialog from '@/components/privacy/PrivacyReportDialog';
import privacyQuery from '@/graphql/privacy/privacyQuery.gql';

export default {
  name: 'PrivacyDataList',
  props: {
    isloading: {
      type: Boolean,
      default: false,
    },
  },
  components: { PrivacyReportDialog },
  data() {
    return {
      optins: {},
      selectedTotalDisplay: 'percentage',
      downloadPrivacyVisible: false,
    };
  },
  apollo: {
    optins: {
      client: 'apiv2',
      query: privacyQuery,
      loadingKey: 'isloading',
      update: data => data.privacyOptinsCount || {},
    },
  },
  computed: {
    respondents() {
      return (this.optins && this.optins.total) || 0;
    },
    getOptins() {
      const optin = this.optins || {};
      if (!optin.total) return [];

      return [
        { type: 'OptIns', count: optin.optin },
        { type: 'Permissions', count: optin.permission },
        { type: 'Over 18', count: optin.age },
      ];
    },
  },
  methods: {
    totalDisplay(count) {
      if (!count) return 0;
      if (this.selectedTotalDisplay === 'percentage') {
        return `${Math.round((count / this.respondents) * 100)}%`;
      }
      return count.toLocaleString();
    },
    getPrivacyTypes() {
      this.downloadPrivacyVisible = true;
    },
    handleDownloadPrivacyVisibilityChanged(visible) {
      this.downloadPrivacyVisible = visible;
    },
    getByChannelType(channel) {
      return collect(this.optins).where('channel_type', channel).all();
    },
  },
};
</script>

<style lang="scss" scoped>
.privacy-list-content {
  padding: 8px;
  background-color: white;
}
.total-display {
  margin-top: 5px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-download-btn {
  padding: 8px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// PrivacyDataList.vue?3eb9df63